import 'popper.js'
import 'bootstrap'
import "bootstrap-datepicker"
// import '@fortawesome/fontawesome-free'
import "@fortawesome/fontawesome-free/css/all"
